<template>
  <v-list
    class="pa-0 ma-0 fonte company-contact-list"
    light
    two-line
    dense
    color="transparent"
    style="min-height: 20vh; max-height: 86vh; overflow: auto;"
  >
    <template v-for="(contato, i) in showFiltereds">
      <v-list-item
        :key="contato._id"
        @click="open(contato)"
        class="fonte pl-3 pr-2 my-2 animate__animated animate__fadeInUp company-contact-list-item"
      >
        <v-list-item-content>
          <v-list-item-title class="fonte-bold">
            {{ contato.label || contato.phone }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ contato.phone }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ purposeLabel(contato.purpose) }} - {{ unityName(contato) }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-avatar rounded size="36" :color="contato.active ? '#e8f5e9' : '#eeeeee'">
            <v-icon :color="contato.active ? 'green' : 'grey'">mdi-card-account-phone-outline</v-icon>
          </v-avatar>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="i < showFiltereds.length - 1" :key="i"></v-divider>
    </template>
    <v-list-item
      style="min-height: 200px;"
      v-intersect="onIntersect"
    ></v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    filtereds: {
      type: Array,
      default: () => []
    },
    purposeLabel: {
      type: Function,
      default: purpose => purpose
    }
  },
  data() {
    return {
      itemsToShow: 12
    };
  },
  computed: {
    showFiltereds() {
      return this.filtereds.slice(0, this.itemsToShow);
    }
  },
  methods: {
    onIntersect() {
      this.itemsToShow += 12;
    },
    open(contato) {
      this.$store.commit("set_contato_empresa", {
        ...contato,
        unity: contato.unity && contato.unity._id || contato.unity,
        responsible_user: contato.responsible_user && contato.responsible_user._id || contato.responsible_user
      });
    },
    unityName(contato) {
      return contato.unity && contato.unity.nome || "Todos os polos";
    }
  }
};
</script>

<style scoped>
.company-contact-list {
  background: transparent !important;
}

.company-contact-list-item {
  background: #f4f5f7;
  border: 1px solid #e2e6ea;
  border-radius: 6px;
  color: #263238;
  min-height: 76px;
}

.company-contact-list-item:hover {
  background: #eceff1;
}
</style>
